<template>
  <!-- 隐私政策和声明 -->
  <div id="PandC" class="container" v-if="this.ppadmin_data">
    <div class="title">
      <span></span>
      <div>
        {{ $route.query.type == "claim" ? claim.title : privacy.title }}
      </div>
      <span></span>
    </div>
    <div
      class="content"
      v-html="$route.query.type == 'claim' ? claim.content : privacy.content"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PrivacyAndClaimView",
  data() {
    return {};
  },
  computed: {
    ...mapState("headerNav", ["ppadmin_data"]),
    privacy() {
      return this.ppadmin_data[7].data;
    },
    claim() {
      return this.ppadmin_data[8].data;
    },
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        // console.log(newVal);
        if (newVal.type == "privacy") {
          this.mainContent = this.privacy;
        } else {
          this.mainContent = this.claim;
        }
      },
    },
  },
  mounted() {},
};
</script>a

<style lang="less" scoped>
#PandC {
  .container {
    background-color: #ccc;
    overflow: hidden;
    padding: 10em;
    text-align: left;
  }
  .title {
    margin: 2em 1em;
    .flex-mixin(row,center,center);
    color: @primary-color;
    span {
      flex: 1;
      border-bottom: 2px solid #e5e5e5;
    }
    > div {
      border: 2px solid #e5e5e5;
      font-family: @font-family-bold;
      font-size: 1.5em;
      padding: 0 1em;
      height: 2.5em;
      line-height: 2.5em;
      .mobile({
                font-size: 1em;
                padding: 0;
                width: 15em
            });
    }
  }
  .content {
    text-align: left;
    letter-spacing: 0.15em;
    line-height: 2em;
    color: #777777;
    .mobile({
            padding: 1em;
        });
  }
}
</style>